import interpretingConfig from '../config/interpreting.json';
import { serviceName, serviceDesc } from './mainServices';

/**
 * Types d'interprétariat — structure de référence définie dans
 * src/config/interpreting.json (labels FR/EN/AR, descriptions, images).
 * La source de vérité en ligne reste la base de données : ce fichier sert
 * de secours local et de mapping visuel (images, descriptions).
 */
export const interpretingGroup = interpretingConfig;

export const interpretingServices = interpretingConfig.services.map((s) => ({
  ...s,
  path: `/services/type/${s.slug}`,
}));

export const getInterpretingService = (slug) => {
  const wanted = String(slug || '').toLowerCase();
  return interpretingServices.find((s) => s.slug.toLowerCase() === wanted) || null;
};

export const interpretingName = serviceName;
export const interpretingDesc = serviceDesc;
